module.exports = __webpack_public_path__ + "static/media/kidcudi-manonthemoon.e7be3336.jpg";